import React from "react";
import { useSelector } from "react-redux";

import "./GameStatusBar.css";

import Stopwatch from "../../ActionPanel/GameDetails/Stopwatch";
import IncorrectGuesses from "../../ActionPanel/GameDetails/IncorrectGuesses";

// Slim row under the header: timer, misses, and one dot per headline.
const GameStatusBar = (props) => {
  const { remainingStories, solvedCount } = props;
  const selectedNewsie = useSelector(
    (state: any) => state.gameReducer.selectedNewsie
  );
  const incorrectGuesses = useSelector(
    (state: any) => state.gameReducer.incorrectGuesses[selectedNewsie]
  );
  const total = remainingStories + solvedCount;

  return (
    <div className="game-status-bar">
      <Stopwatch />
      <IncorrectGuesses incorrectGuesses={incorrectGuesses} />
      {total > 0 && (
        <div className="game-progress" aria-label={`${solvedCount} of ${total} solved`}>
          <div className="game-progress-dots">
            {Array.from({ length: total }, (_, i) => (
              <span key={i} className={`game-progress-dot ${i < solvedCount ? "solved" : ""}`} />
            ))}
          </div>
          <span className="game-progress-count">
            {solvedCount}/{total}
          </span>
        </div>
      )}
    </div>
  );
};

export default GameStatusBar;
